import { COLLECT_LOGIN_DETAILS } from '../../../actions/motorPrivateRW/auth';
import { COLLECT_CAR_DETAILS_FORM_DATA, COLLECT_VEHICLE_DETAILS_FORM_DATA, MOTOR_INSURANCE_CAR_DETAILS_FORM_SET_VALUE } from '../../../actions/motorPrivateRW/carDetails';
import { COLLECT_DOCUMENTS_FORM_DATA } from '../../../actions/motorPrivateRW/Documents';
import { TRIGGER_FETCH_RW_AGENTS } from '../../../actions/motorPrivateRW/motorAgentModal';
import { COLLECT_PAYLOAD_DATA } from '../../../actions/motorPrivateRW/payloadCollection';
import { CHECK_PAYMENTS_STATUS, CHECK_SECOND_PAYMENTS_STATUS, TRIGGER_PAYMENTS_STK_PUSH } from '../../../actions/motorPrivateRW/payments';
import { COLLECT_PERSONAL_DETAILS_FORM_DATA, TRIGGER_GET_NATIONALITIES, TRIGGER_GET_NIDA } from '../../../actions/motorPrivateRW/personalDetails';
import {
    COLLECT_MOTOR_INSURANCE_QUOTE_FORM_DATA,
    COLLECT_MOTOR_INSURANCE_QUOTE_API_FORM_DATA,
    COLLECT_SHARE_QUOTE_FORM_DATA,
    TRIGGER_GET_ALL_CAR_MAKES,
    TRIGGER_GET_ALL_CAR_MODELS,
    TRIGGER_GET_ALL_OCCUPANTS_LIMITS,
    TRIGGER_GET_ALL_VEHICLE_TYPES_LIST,
} from '../../../actions/motorPrivateRW/quote';
import { getAgentsService } from './agent';
import { getCarMakesService } from './carMake';
import { getCarModelsService } from './carModels';
import { validInsuranceService } from './checkValidInsurance';
import { saveDocumentsService } from './documents';
import { loginService } from './login';
import { getNationalityService } from './nationalities';
import { getNidaListService } from './nida';
import { getOccupantLimitsService } from './occupantLimits';
import { payloadSubmitService } from './payloadCollection';
import { checkSecondTime, paymentsStkService, paymentsStkStatusService } from './payments';
import { savePersonalDetailsService } from './personalDetails';
import { premiumCalculationService } from './premiumCalculation';
import { savePaymentsService } from './savePayments.js';
import { saveQuoteService } from './saveQuote';
import { shareQuoteService } from './shareQuote';
import { saveVehicleDetailsService } from './vehicleDetails';
import { getVehicleTypesListService } from './vehicleTypes';

export const rwMotorInsuranceCover = (store, next, action) => {

    if (action.type.startsWith(TRIGGER_PAYMENTS_STK_PUSH)) {
        return paymentsStkService(store, next, action);
    }
    if (action.type.startsWith(CHECK_PAYMENTS_STATUS)) {
        return paymentsStkStatusService(store, next, action);
    }
    if (action.type.startsWith(CHECK_SECOND_PAYMENTS_STATUS)) {
        return checkSecondTime(store, next, action);
    }
    if (action.type.startsWith(COLLECT_MOTOR_INSURANCE_QUOTE_FORM_DATA)) {
        return premiumCalculationService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_PAYLOAD_DATA)) {
        return savePaymentsService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_SHARE_QUOTE_FORM_DATA)) {
        return shareQuoteService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_LOGIN_DETAILS)) {
        return loginService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_ALL_CAR_MAKES)) {
        return getCarMakesService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_ALL_CAR_MODELS)) {
        return getCarModelsService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_NATIONALITIES)) {
        return getNationalityService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_ALL_VEHICLE_TYPES_LIST)) {
        return getVehicleTypesListService(store, next, action);
    }


    if (action.type.startsWith(TRIGGER_GET_ALL_OCCUPANTS_LIMITS)) {
        return getOccupantLimitsService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_CAR_DETAILS_FORM_DATA)) {
        return validInsuranceService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_NIDA)) {
        return getNidaListService(store, next, action);
    }
    if (action.type.startsWith(TRIGGER_FETCH_RW_AGENTS)) {
        return getAgentsService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_MOTOR_INSURANCE_QUOTE_API_FORM_DATA)) {
        return saveQuoteService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_PERSONAL_DETAILS_FORM_DATA)) {
        return savePersonalDetailsService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_VEHICLE_DETAILS_FORM_DATA)) {
        return saveVehicleDetailsService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_DOCUMENTS_FORM_DATA)) {
        return saveDocumentsService(store, next, action);
    }
    return null;
};
